<!-- js/components/Shared/VueTabs.vue -->

<template>
    <div class="tabs-wrapper">
        <ul class="inline-flex space-x-2" v-if="!isMobile">
            <li
            v-for="(header, index) in ui.headers"
            @click="clickedTab(index)"
            class="vue-tabs-tab py-2 px-4 text-sm uppercase font-medium cursor-pointer"
            :id="`tab_${header.toLowerCase().replace(' ', '_')}`"
            :class="{ 'bg-white text-cal-204285': index == ui.idx, 'bg-cal-204285 text-white': index != ui.idx, disabled: !allowStepClick(index) }"
            >{{ header }}</li>
        </ul>
        <div class="tabs-panes bg-white">
          <div class="px-6 py-6">
            <slot></slot>
          </div>
        </div>
    </div>
</template>

<script>

export default {

    props: {
        childName: {
            default: ".tab"
        },
        allowStepClick: {
            default: function () { return function () { return true; } }
        }
    },

    data () {
        return {
            ui: {
                headers: [],
                tabs: [],
                total: 0,
                idx: 0,
            },
            isMobile: this.$root.$data.isMobile
        }
    },

    mounted: function() {

    },

    beforeUpdate() {
      var tabs = this.$el.querySelectorAll(this.childName);
      this.ui = {
        tabs: tabs,
        total: tabs.length,
        headers: Array.prototype.map.call(tabs, function(itm) { return itm.getAttribute("title") }),
        idx: this.ui.idx,
      }

      if (!this.isMobile) {
        this.showTab(this.ui.idx)
      }
    },

    methods: {
        clickedTab (idx) {
            if (!this.allowStepClick(idx)) return;
            this.showTab(idx);
        },

        showTab (idx) {

            if (idx < 0) idx = 0;
            if (idx > this.ui.total) idx = this.ui.total;

            for (var i = 0; i < this.ui.tabs.length; i++) {
                if (i == idx) {
                    this.ui.tabs[i].style.display = 'block';
                }
                else {
                    this.ui.tabs[i].style.display = 'none';
                }
            }

            this.ui.idx = idx
        }
    }
}
</script>
